import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';
import { INVENTORY_RULES, access, param } from '../../access';

const InventoryOptions = withLazyLoading(() => import('../../pages/InventoryOptions'));
const Solution = withLazyLoading(() => import('../../pages/Solution'));
const SolutionDetail = withLazyLoading(() => import('../../pages/SolutionDetail'));
const SolutionDetailsForChemical = withLazyLoading(
  () => import('../../pages/SolutionDetailsForChemical')
);
const ChemicalLog = withLazyLoading(() => import('../../pages/ChemicalLog'));
const InventoryCategoryLogs = withLazyLoading(() => import('../../pages/InventoryCategoryLogs'));
const StoreManagement = withLazyLoading(() => import('../../pages/StoreManagement'));
const StoreConfiguration = withLazyLoading(() => import('../../pages/StoreConfiguration'));
const StoreDetails = withLazyLoading(() => import('../../pages/StoreDetails'));

const inventoryRoutes = [
  {
    path: 'StoreMaintenance',
    element: <InventoryOptions />,
    handle: { ...createCrumbHandle('Store Maintenance'), ...access(INVENTORY_RULES.stock) },
  },
  {
    path: '/Solution',
    element: <Solution />,
    handle: { ...createCrumbHandle('Solutions'), ...access(INVENTORY_RULES.stock) },
  },
  {
    path: '/SolutionDetail',
    element: <SolutionDetail />,
    handle: { ...createCrumbHandle('Solution Details'), ...access(INVENTORY_RULES.useStock) },
  },
  {
    path: '/Chemicals/:plantId',
    element: withPostHogTracker(<InventoryCategoryLogs />),
    handle: { ...createCrumbHandle('Chemicals'), ...access(INVENTORY_RULES.useStock, param('plantId')) },
  },
  {
    path: '/Consumables/:plantId',
    element: <InventoryCategoryLogs />,
    handle: { ...createCrumbHandle('Consumables'), ...access(INVENTORY_RULES.useStock, param('plantId')) },
  },
  {
    path: '/ElectricalSpare/:plantId',
    element: <InventoryCategoryLogs />,
    handle: { ...createCrumbHandle('Electrical Spares'), ...access(INVENTORY_RULES.useStock, param('plantId')) },
  },
  {
    path: '/MechanicalSpare/:plantId',
    element: <InventoryCategoryLogs />,
    handle: { ...createCrumbHandle('Mechanical Spares'), ...access(INVENTORY_RULES.useStock, param('plantId')) },
  },
  {
    path: '/Tools/:plantId',
    element: <InventoryCategoryLogs />,
    handle: { ...createCrumbHandle('Tools'), ...access(INVENTORY_RULES.useStock, param('plantId')) },
  },
  {
    path: '/ToolForCleaning/:plantId',
    element: <InventoryCategoryLogs />,
    handle: { ...createCrumbHandle('Cleaning Tools'), ...access(INVENTORY_RULES.useStock, param('plantId')) },
  },
  {
    path: '/StoreConfiguration',
    handle: createCrumbHandle('Stores'),
    children: [
      {
        index: true,
        element: <StoreConfiguration />,
        handle: access(INVENTORY_RULES.catalog),
      },
      {
        path: 'StoreManagement/:storeId',
        element: withPostHogTracker(<StoreManagement />),
        handle: { ...createCrumbHandle('Store Management'), ...access(INVENTORY_RULES.catalog) },
      },
    ]
  },
  {
    path: '/StoreDetails',
    handle: createCrumbHandle('Store Details'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<StoreDetails />),
        handle: access(INVENTORY_RULES.useStock),
      },
      {
        path: 'ChemicalLogs',
        handle: createCrumbHandle('Chemical Logs'),
        children: [
          {
            index: true,
            element: withPostHogTracker(<ChemicalLog />),
            handle: access(INVENTORY_RULES.movementLogs),
          },
          {
            path: 'SolutionDetailsForChemical',
            element: <SolutionDetailsForChemical />,
            handle: { ...createCrumbHandle('Solution Details For Chemical'), ...access(INVENTORY_RULES.movementLogs) },
          },
        ]
      },
    ]
  },
];

export default inventoryRoutes;
